<template>
  <!DOCTYPE html>
  <html>
    <head>
      <title>Oferty</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="description" content="Destino project" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="stylesheet" type="text/css" href="/styles/bootstrap4/bootstrap.min.css" />
      <link
        href="/plugins/font-awesome-4.7.0/css/font-awesome.min.css"
        rel="stylesheet"
        type="text/css"
      />
      <link rel="stylesheet" type="text/css" href="/styles/offers_styles.css" />
      <link rel="stylesheet" type="text/css" href="/styles/offers_responsive.css" />
    </head>
    <body>
      <div class="home">
        <!-- Image by https://unsplash.com/@peecho -->
        <div
          class="home_background parallax-window"
          data-parallax="scroll"
          :style="{
            'background-image': `url(${trip.photo || '/images/offers.jpg'})`,
          }"
          data-speed="0.8"
        >
          <div v-if="!readOnly" class="upload-image">
            <i v-show="!uploadingFile" class="fa fa-camera" />
            <i v-show="uploadingFile" class="fa fa-spinner fa-spin" />
            <input ref="fileInput" type="file" accept="image/*" @change="uploadFile" />
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="home_content">
                <div class="home_content_inner">
                  <div class="home_title">
                    <HiddenInput v-model="trip.title" :read-only="readOnly" />
                  </div>
                  <div class="home_breadcrumbs">
                    <ul class="home_breadcrumbs_list">
                      <li class="home_breadcrumb"><a href="index.html">Oferty</a></li>
                      <li class="home_breadcrumb">{{ trip.title }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_title text-center">
        <h2>
          <HiddenInput v-model="trip.title" :read-only="readOnly" />
        </h2>
        <div class="trip-date">
          <span>Od {{ trip.start_date }}</span>
          <span>Do {{ trip.end_date }}</span>
        </div>
      </div>
      <div class="container">
        <jodit-vue v-if="loggedUser && previewHidden" v-model="trip.description" />
        <div v-show="!previewHidden" v-html="trip.description" />
        <div v-show="!readOnly" class="admin-controls">
          <div>Data rozpoczęcia <input v-model="trip.start_date" type="date" /></div>
          <div>Data zakończenia <input v-model="trip.end_date" type="date" /></div>
          <div>Wyróżnienie <input v-model="trip.is_favourite" type="checkbox" /></div>
        </div>
        <div v-show="loggedUser" class="description-controls">
          <button class="m-button" @click="previewHidden = !previewHidden">Podgląd</button>
          <button class="m-button" :disabled="saving" @click="save">
            <i v-show="saving" class="fa fa-spinner fa-spin" />
            Zapisz
          </button>
          <delete-button :disabled="deleting" @confirm="deleteTrip"> </delete-button>
        </div>
      </div>

      <script2 src="/js/jquery-3.2.1.min.js"></script2>
      <script2 src="/styles/bootstrap4/popper.js"></script2>
      <script2 src="/styles/bootstrap4/bootstrap.min.js"></script2>
      <script2 src="/plugins/greensock/TweenMax.min.js"></script2>
      <script2 src="/plugins/greensock/TimelineMax.min.js"></script2>
      <script2 src="/plugins/scrollmagic/ScrollMagic.min.js"></script2>
      <script2 src="/plugins/greensock/animation.gsap.min.js"></script2>
      <script2 src="/plugins/greensock/ScrollToPlugin.min.js"></script2>
      <script2 src="/plugins/Isotope/isotope.pkgd.min.js"></script2>
      <script2 src="/plugins/easing/easing.js"></script2>
      <script2 src="/plugins/parallax-js-master/parallax.min.js"></script2>
      <script2 src="/js/offers_custom.js"></script2>
    </body>
  </html>
</template>

<script>
import cli from '@/http.js'
import { JoditVue } from 'jodit-vue'
import 'jodit/build/jodit.min.css'
import { mapState } from 'vuex'
import HiddenInput from '@/components/HiddenInput.vue'
import DeleteButton from '@/components/DeleteButton.vue'

export default {
  name: 'Trip',
  components: {
    HiddenInput,
    JoditVue,
    DeleteButton,
  },
  data() {
    return {
      trip: {},
      previewHidden: false,
      saving: false,
      deleting: false,
      uploadingFile: false,
    }
  },
  async mounted() {
    if (this.id == 'new' && this.loggedUser) {
      this.trip = {
        title: 'Nowa wycieczka',
        description: 'Opis wycieczki',
        photo: '',
      }
    } else {
      const resp = await cli.get(`/trips/${this.id}/`)
      this.trip = resp.data
    }
    if (this.loggedUser) {
      this.previewHidden = true
    }
  },
  computed: {
    ...mapState(['loggedUser']),
    id() {
      return this.$route.params.id
    },
    uploadUrl() {
      return cli.defaults.baseURL + '/uploads/'
    },
    readOnly() {
      return !this.loggedUser || !this.previewHidden
    },
  },
  methods: {
    async save() {
      this.saving = true
      try {
        if (this.id === 'new') {
          let resp = await cli.post('/trips/', this.trip)
        } else {
          let resp = await cli.patch(`/trips/${this.id}/`, this.trip)
        }
        this.$notify({
          title: 'Zapisywanie wycieczki',
          text: 'Sukces.',
          type: 'success',
        })
      } catch (err) {
        this.$notify({
          title: 'Zapisywanie wycieczki',
          text: err.message,
          type: 'error',
        })
      }
      this.saving = false
    },
    async uploadFile(event) {
      this.uploadingFile = true
      const file = this.$refs.fileInput.files[0]
      let formData = new FormData()
      formData.append('file', file)
      try {
        const resp = await cli.post('/uploads/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        this.trip.photo = resp.data.file
        this.$notify({
          title: 'Upload',
          text: 'success',
          type: 'success',
        })
      } catch (err) {
        this.$notify({
          title: 'Upload',
          text: err.message,
          type: 'error',
        })
      } finally {
        this.uploadingFile = false
      }
    },
    async deleteTrip() {
      this.deleting = true
      try {
        await cli.delete(`/trips/${this.id}`)
        this.$notify({
          title: 'Wycieczka usunięta',
          type: 'success',
        })
      } catch (err) {
        this.$notify({
          title: 'Usuwanie wycieczki',
          text: err.message,
          type: 'error',
        })
      }
      this.deleting = false
    },
  },
}
</script>

<style scoped>
.container {
  min-height: 400px;
  margin-bottom: 40px;
}
.description-controls {
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 10px;
}
.home_content_inner {
  background: #8080803b;
  padding: 20px;
  border-radius: 3px;
}
.admin-controls {
  margin-top: 10px;
}
.upload-image {
  bottom: 5px;
  right: 5px;
  position: absolute;
  background: rgba(255, 255, 255, 0.72);
  padding: 20px;
  transition: all 0.3s;
  z-index: 10;
}
.upload-image:hover {
  background: rgba(255, 255, 255, 0.9);
}
.trip-date {
  margin-bottom: 11px;
}
</style>
